import { useEffect, useState, Suspense, lazy, useMemo } from "react";
import { Layout, Card, Affix } from "antd";
import Spinner from "../../component/Spinner/Spinner";
import {
  SearchOutlined, PlusSquareOutlined, PieChartOutlined, UserAddOutlined,
  FundViewOutlined, BranchesOutlined, MessageOutlined, GiftOutlined
} from "@ant-design/icons";

import { Route, Switch, useRouteMatch, useHistory } from "react-router-dom";

import RegisterMember from "../../view/Manage/RegisterMember";
import SearchMember from "../../view/Manage/SearchMember";
import Broadcast from "../../view/Broadcast/Broadcast";
import Delivery from "../../view/Delivery/Search";
import SearchBranch from "../../view/Manage/SearchBranch";
import SearchUser from "../../view/Manage/SearchUser";
import Consent from "../../view/Manage/Consent";

import TopicMenu from "../../component/TopicMenu";
import NavBar from "../../component/NavBar/NavBar";
import SideBar from "../../component/SideBar/SideBar";

const PromotionIndex = lazy(() => import("../../view/Promotion/PromotionIndex"));
const PromotionAdd = lazy(() => import("../../view/PromotionAdd/PromotionAdd"));

const Full = (props) => {
  const history = useHistory();
  const { path } = useRouteMatch();

  const legacyComponents = [
    <SearchMember />,
    <RegisterMember />,
    <Broadcast />,
    <Delivery />,
    <SearchUser />,
    <SearchBranch />,
    <Consent />
  ];

  const [contentIndex, setContentIndex] = useState(0);
  const [selectedKey, setSelectedKey] = useState("0");
  const [menuApi, setMenuApi] = useState([]);

  useEffect(() => {
    const access_token = localStorage.getItem("access_token");
    if (!access_token) window.location = `/#/login`;

    const menu = JSON.parse(localStorage.getItem("menu"));
    setMenuApi(menu || []);
  }, []);

  const topics = menuApi ? menuApi.map((item) => item.menu_th) : [];

  const promotionIndex = useMemo(() => {
    if (!menuApi || menuApi.length === 0) return -1;

    return menuApi.findIndex(
      (m) =>
        m.menu_code === "800" ||
        m.menu_en === "Promotion" ||
        m.module_en === "Promotion Management"
    );
  }, [menuApi]);

  const changeSelectedKey = (event) => {
    const k = +event.key;
    setSelectedKey(String(k));
    setContentIndex(k);

    if (promotionIndex !== -1 && k === promotionIndex) {
      history.push("/management/promotions");
    } else {
      history.push("/management");
    }
  };

  const Menu = (
    <TopicMenu
      icon={[
        <SearchOutlined />,
        <PlusSquareOutlined />,
        <PieChartOutlined />,
        <FundViewOutlined />,
        <UserAddOutlined />,
        <BranchesOutlined />,
        <MessageOutlined />,
        <GiftOutlined />
      ]}
      topics={topics}
      selectedKey={selectedKey}
      changeSelectedKey={changeSelectedKey}
    />
  );

  const search = props.location.search;
  const params = new URLSearchParams(search);
  const key = params.get("key");

  useEffect(() => {
    const { pathname } = props.location;

    if (pathname.startsWith("/management/promotions")) {
      if (promotionIndex !== -1) {
        setSelectedKey(String(promotionIndex));
        setContentIndex(promotionIndex);
      }
      return;
    }

    if (pathname === "/management") {
      if (key !== null) {
        const k = +key;
        setSelectedKey(key);
        setContentIndex(k);

        if (promotionIndex !== -1 && k === promotionIndex) {
          history.push("/management/promotions");
        }
      } else {
        setSelectedKey("0");
        setContentIndex(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.location.pathname, key, promotionIndex, history]);

  return (
    <div>
      <Affix>
        <NavBar menu={Menu} name={"PHARMAX USER"} />
      </Affix>
      <Layout>
        <Affix offsetTop={60}>
          <SideBar menu={Menu} />
        </Affix>

        <Layout.Content className="content">
          <Suspense fallback={<Spinner visible={true} />}>
            <Switch>
              {/* หน้า default ใต้ /management */}
              <Route exact path={`${path}`}>
                <Card className="ant-card-bordered">
                  {/* ถ้า index นี้ไปเกินจำนวน legacyComponents จะได้ null */}
                  {legacyComponents[contentIndex] || null}
                </Card>
              </Route>

              {/* โปรโมชันใต้ Full */}
              <Route exact path={`${path}/promotions`}>
                <Card className="ant-card-bordered">
                  <PromotionIndex />
                </Card>
              </Route>

              <Route exact path={`${path}/promotions/add`}>
                <Card className="ant-card-bordered">
                  <PromotionAdd />
                </Card>
              </Route>

              <Route exact path={`${path}/promotions/add/:id`}>
                <Card className="ant-card-bordered">
                  <PromotionAdd />
                </Card>
              </Route>
            </Switch>
          </Suspense>
        </Layout.Content>
      </Layout>

      <div className="footer" style={{ textAlign: "right" }}>
        {window.software_version}
      </div>
    </div>
  );
};

export default Full;
